import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupplierQuotation, SupplierQuotationCreate, SupplierQuotationFilter } from '../data/supplierQuotation';

export function createSupplierQuotationService(client: AxiosInstance) {
  return createCrudService<SupplierQuotation, SupplierQuotationCreate, SupplierQuotationFilter>(
    client,
    '/purchase/SupplierQuotation',
    'id',
  );
}

export type SupplierQuotationService = CrudService<SupplierQuotation, SupplierQuotationCreate, SupplierQuotationFilter>;
